
import React, { useContext } from 'react'
import { ApiContext } from '../../context/ApiContext'
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router'
import Axios from '../../api/api'
import loader from '../../img/loader.png'
import { connect } from 'react-redux';

import { loginCall, callEditor, ascCall } from '../../action';

const Login = (props) => {
    const { logUser, user, call, editor } = props;
    const [formData, updateFormData] = React.useState('');
    const [cookies, setCookie] = useCookies(['isLoggedin', 'AscID', 'isLoggedinEditor', 'EditorID']);
    const provideHistory = useHistory()


    const handleChange = (e) => {
        updateFormData({
            ...formData,
            [e.target.name]: e.target.value.trim()
        });
    };

    // async function handleAdmin() {
    //     const loginErr = document.querySelector('.login__error').classList
    //     await Axios.post('/signin', { ...formData })
    //         .then(res => {
    //             setUser(res.data.user)
    //             setCookie('isLoggedinAdmin', true)
    //             provideHistory.push('/admin')
    //         })
    //         .catch(err => loginErr.remove('none'))
    // }

    // async function handleAsc() {
    //     const loginErr = document.querySelector('.login__error').classList
    //     await Axios.post('/signin', { ...formData })
    //         .then(res => {
    //             setUser(res.data.editor)
    //             setCookie('isLoggedinASC', true)
    //             setCookie('AscID', res.data.asc._id)
    //             // provideHistory.push('/asc')
    //             window.open('asc')
    //         })
    //         .catch(err => loginErr.remove('none'))
    // }

    // async function handleEditor() {
    //     const loginErr = document.querySelector('.login__error').classList
    //     await Axios.post('/signin', { ...formData })
    //         .then(res => {
    //             setUser(res.data.asc)
    //             setCookie('isLoggedinEditor', true)
    //             setCookie('EditorID', res.data.editor._id)
    //             provideHistory.push('/editor');
    //         })
    //         .catch(err => loginErr.remove('none'))
    // }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const loginErr = document.querySelector('.login__error').classList
        try {
            const { email } = formData;
            const splitMail = email.split('-')
            const index = splitMail.indexOf("agro")
            if (index === 0) {
                logUser("admin", formData)
                provideHistory.push('/admin')
            } else if (index === 1) {
                logUser("asc", formData);
                provideHistory.push('/asc')
                // handleAsc();
            } else {
                logUser("editor", formData)
                editor(user.editor._id)
                provideHistory.push('/editor')



                // handleEditor();
            }

        } catch (error) {
            loginErr.remove('none')
        }

    };
    return (
        <>
            <section className='section__drought'>
                <div className='section__drought__main section__drought__main__img__2'>
                    <div className="drought">
                        <div className="drought__title" >
                            <h1 style={{ margin: "1rem 2rem" }} className="section__title">Login</h1>
                        </div>
                        <form method='post' onSubmit={handleSubmit} autoComplete='off' className="form">
                            <div className="form__control">
                                <input placeholder='User ID' onChange={handleChange} name="email" type="text" className="form__input" />
                                <label htmlFor="email" className="form__label">User ID</label>
                            </div>
                            <div className="form__control">
                                <input placeholder='Password' onChange={handleChange} name="password" type="password" className="form__input" />
                                <label htmlFor="name" className="form__label">Password</label>
                            </div>
                            <div className="drought__box" style={{ margin: '0' }}>
                                <span className='none login__error'>Username or Password Incorrect</span>
                                <button type='submit' className='login__btn' target='_blank'>Login {'->'} </button>
                            </div>
                        </form>
                    </div>
                </div>
                <img src={loader} alt="loader" className='login__loader' />
            </section>
        </>
    )
}
const mapStateToProps = (state) => {
    return state;
}

export default connect(mapStateToProps, { editor: callEditor, call: ascCall, logUser: loginCall })(Login);